<template>
    <div class="col-sm-12 col-xs-12 text-center">

            <img src="img/academic.png" width="80px" height="auto" >
            <h4 >Pelican Academy</h4>

        <hr>

        <ul class="no-padding" v-for="(video, key) in videos">
            <li class="video-containter" @click="video.isOpen = true" >
                <h5 >{{video.title}}</h5>
                <video width="100%" height="200" controls v-if="video.isOpen">
                    <source v-bind:src="absoluteLink(video.src)" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
                <a v-bind:href="absoluteLink(video.src)" target="_blank" v-show="video.isOpen" class="share"><h5>Open in a new tab</h5></a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                videos : [
                    { src:'media/videos/demo.mp4', title:'DEMO', isOpen:false},
                    { src:'media/videos/forfait.mp4',title:'FORFAIT', isOpen: false},
                    { src:'media/videos/sans_signer_avant.mp4',title:'SANS SIGNER AVANT', isOpen :false},
                    { src:'media/videos/update_hour.mp4', title:'MODIFIER HEURE D\'ARRIVĖE', isOpen :false},
                ]
            }
        },created(){
            console.log(process.env.VUE_APP_API_BASE_URL_ASSETS);
        },
        methods: {
            absoluteLink(RelativeLink){
                return process.env.VUE_APP_API_BASE_URL_ASSETS +'/'+ RelativeLink;
            },
            nl2br(string){
                return string.replace(/(?:\r\n|\r|\n)/g, '<br>');
            },
        },
    }

</script>


<style lang="scss" scoped>
    .video-containter {
        background-color: #f4f4f4;
        border: 1px solid #ecf3e9;
        margin-bottom: 10px;
        border-radius: 8px;
        text-align: left;
    }

    .video-containter h5{
        padding:8px 8px;
        margin:0px 0px
    }

    .share{
        color: #4567ff;
    }
    

</style>